import React, { useContext, useEffect, useState } from 'react'
import { Alert, Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import moment from 'moment-timezone'

import { PreferredDateTimeContext } from '../Context/PreferredDateTimeContext'

const formatLocal = (value) => value.format(moment.HTML5_FMT.DATETIME_LOCAL)

const CommsSnoozeModal = ({ isOpen, toggle, onSnooze }) => {
  const { preferredDateTimeInfo } = useContext(PreferredDateTimeContext)
  const timezone = preferredDateTimeInfo?.timezone || moment.tz.guess()
  const [dateTime, setDateTime] = useState('')
  const [error, setError] = useState('')
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (isOpen) {
      setDateTime(formatLocal(moment().tz(timezone).add(1, 'hour').startOf('minute')))
      setError('')
      setSaving(false)
    }
  }, [isOpen, timezone])

  const minDateTime = formatLocal(moment().tz(timezone).add(1, 'minute').startOf('minute'))

  const handleSnooze = async () => {
    const selected = moment.tz(dateTime, moment.HTML5_FMT.DATETIME_LOCAL, true, timezone)
    if (!dateTime || !selected.isValid() || !selected.isAfter(moment())) {
      setError('Snooze time must be in the future')
      return
    }

    setSaving(true)
    setError('')
    try {
      await onSnooze(selected)
      toggle()
    } catch (err) {
      setError(err?.message || 'Failed to snooze conversation')
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Snooze Conversation</ModalHeader>
      <ModalBody>
        {error ? <Alert color="danger">{error}</Alert> : null}
        <FormGroup>
          <Label for="conversation-snoozed-until">Snooze until</Label>
          <Input
            id="conversation-snoozed-until"
            type="datetime-local"
            value={dateTime}
            min={minDateTime}
            onChange={(event) => {
              setDateTime(event.target.value)
              setError('')
            }}
          />
          <div className="text-muted small mt-2">
            Times are shown in {moment.tz(timezone).format('z')}.
          </div>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle} disabled={saving}>Cancel</Button>
        <Button color="primary" onClick={handleSnooze} disabled={saving || !dateTime}>
          {saving ? 'Snoozing…' : 'Snooze'}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default CommsSnoozeModal
